import { bl_fi_sales_contract_template_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class SalesContractTemplateHdrContainerModel extends BaseContainerModel {
    bl_fi_sales_contract_template_hdr: bl_fi_sales_contract_template_hdr_RowClass = new bl_fi_sales_contract_template_hdr_RowClass();
}